{
  "title": "Editar nombre FBO",
  "nameLabel": "Nombre",
  "cancelButton": "Cancelar",
  "saveButton": "Guardar"
}
